import ListenToEarnDialog from "./ListenToEarnDialog";

export default function PageFour() {


    return (
        <div class="mt-5">
            <h1 class="text-center text-light">Listen to Earn</h1>
            <div className="container">
            <div className="row mt-5">
                <div className="col">
                    <ListenToEarnDialog imgSrc={require("../../images/artist.png")}
                                        title={"Democratize music and give the maximum profit back to the musician"}
                                        context={["Step 1: Download Lepton DAPP/Open the Lepton web and Register",
                                            "Step 2: Create a LeptonMusic crypto wallet as the address to receive Tokens",
                                            "Step 3: Upload music and mint your own music NFT",
                                            "Step 4: Automatically get LeptonmusicCoin (LMC)"]}
                                        exImg={require("../../images/ProcessMusician.jpeg")}/>

                </div>
                <div className="col">
                    <ListenToEarnDialog imgSrc={require("../../images/audience.png")}
                                        title={"LeptonMusic provides a pure musical environment for audience"}
                                        context={["Step 1: Download Lepton DAPP/Open the Lepton web and Register",
                                        "Step 2: Create a LeptonMusic crypto wallet as the address to receive Tokens",
                                        "Step 3: Get music NFTs (buy/rent/airdrop for free)",
                                        "Step 4: Listen to music and earn LeptonMusicCoin (LMC)"]}
                                        exImg={require("../../images/ProcessMap.jpeg")}/>

                </div>
                <div className="col">
                    <ListenToEarnDialog imgSrc={require("../../images/investor.png")}
                                        title={"Support musicians with investment and share royalties"}
                                        context={["Buy music NFTs to earn",
                                        "Step 1: Buy music NFTs",
                                        "Step 2: Hold NFTs to get dividends",
                                        "Or, invest in music NFTs to earn",
                                        "Step 1: Register to become a music investor",
                                        "Step 2: Stake music coins to the pool under specific NFT",
                                        "Step 3: End the staking to enjoy high ROI, and participate in dividends"]}
                                        exImg={require("../../images/ProcessInvestor.jpeg")}/>


                </div>
                <div className="col">
                    <ListenToEarnDialog imgSrc={require("../../images/community.png")}
                                        title={"Crypto Artist Alliance on LeptonMusic platform"}
                                        context={["The artist community can register on the LeptonMusic platform and bring more and more" +
                                        "popularity to music NFT through cooperation and interaction. More details will be released."]}
                                        exImg={require("../../images/Process Community.jpeg")}/>

                </div>

            </div>
            </div>
        </div>
    )
}